export default __webpack_public_path__ + "static/media/desktop-icon.b8c72a75.svg";